import type { FC } from 'react';

import type { AssignmentRubric, QuestionRubric } from 'bundles/grading/api/types';
import InlineFeedbackButton from 'bundles/grading/components/staff-graded-assignments/form-parts/InlineFeedbackButton';
import RubricShell from 'bundles/grading/components/staff-graded-assignments/form-parts/RubricShell';
import { isRubricBoxView } from 'bundles/grading/utils/submissionUtils';

export type RubricProps = {
  rubric: AssignmentRubric | QuestionRubric;
  isReadOnly?: boolean;
};

export const getRubricComponent = (rubric: AssignmentRubric | QuestionRubric): FC<RubricProps> => {
  if (isRubricBoxView(rubric)) {
    return InlineFeedbackButton;
  }

  return RubricShell;
};
